module.exports = ".chart{height:100%}\n"